import { IAppState, TActions } from '../../../common/state';
import { EConditionType, jq } from '../../../json_query';
import { getParamChangedAction } from './fabrics/multiselect_param_reducer';

type TBuildingConditionChangedActionType = 'filters/building_condition/BUILDING_CONDITION_CHANGED';
export const IBuildingConditionChangedActionType = 'filters/building_condition/BUILDING_CONDITION_CHANGED' as TBuildingConditionChangedActionType;

export interface IBuildingConditionChangedAction {
  type: 'filters/building_condition/BUILDING_CONDITION_CHANGED';
  paramType: EConditionType;
  value: boolean;
}

export const changeBuildingCondition = getParamChangedAction<EConditionType, TBuildingConditionChangedActionType>(
  IBuildingConditionChangedActionType,
);

export function buildingConditionTypeReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case IBuildingConditionChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: action.value
            ? jq(state.filters.jsonQuery).setBuildingCondition(action.paramType)
            : jq(state.filters.jsonQuery).unsetBuildingCondition(action.paramType),
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-buildingCondition') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).unsetBuildingCondition(action.tag.value),
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).unsetBuildingConditions(),
        },
      };

    default:
      return state;
  }
}
